import { Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Card, Stack, Link, Container, Typography, Button } from '@mui/material';
// routes
// hooks
import useAuth from '../../hooks/useAuth';
// layouts
// components
import Page from '../../components/Page';
import { LoginForm } from '../../components/authentication/login';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  backgroundColor: '#F0F2F5',
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 10,
  justifyContent: 'center',
  color: 'white',
  backgroundColor: '#1C347B',
  textAlign: 'center',
  padding: '30px 10px',
  marginTop: '-21px'
}));

const ContentWholeStyle = styled('div')(({ theme }) => ({
  backgroundColor: '#FFFFFFFF',
  borderRadius: 20,
  padding: '0 20px',
  paddingBottom: '20px'
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 400,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Login() {
  const { method, login } = useAuth();

  const handleLoginAuth0 = async () => {
    try {
      await login();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <RootStyle title="Login | ProPlus">
      <Container maxWidth="sm">
        <ContentStyle>
          <ContentWholeStyle>
            <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
              <Box sx={{ flexGrow: 1 }}>
                <SectionStyle>
                  <Typography variant="h2" gutterBottom>
                    ProPlus
                  </Typography>
                </SectionStyle>
              </Box>
            </Stack>
            <LoginForm />
          </ContentWholeStyle>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
